module.exports = __webpack_public_path__ + "media/images/front/icon_mymenu-59880e886454c0288be31beb24096065.png";